/**
 * can be overwritten in saas or ee editions
 * */
import { planFeatures } from 'App/utils/planFeatures';

/** feature keys the backend returns in `/account` -> `plan.features` */
export type PlanFeature = 'agent-issues' | 'agent-tests';

export const hasPlanFeature = (feature: PlanFeature): boolean =>
  planFeatures().includes(feature);

/**
 * Smart Issues pages + the agentic parts of segments / saved searches
 * (capture toggle, agent instructions, "Issues Agent" column).
 */
export const agentIssuesEnabled = (): boolean => hasPlanFeature('agent-issues');

/** Test agent: the Tests page and its settings tab (SmartTests). */
export const agentTestsEnabled = (): boolean => hasPlanFeature('agent-tests');

/** Surfaces shared by both agents: the Agents menu section and its preferences tab. */
export const anyAgentEnabled = (): boolean =>
  agentIssuesEnabled() || agentTestsEnabled();

export const hasAi = true;
export const hasHealth = false;
export const hasIssuesSummary = true;
export const hasSampling = false;

export const menuHidden = {
  clips: true,
  vault: false,
  bookmarks: true,
  kai: false,
  billing: false,
  videoExport: false,
  dataAnalytics: false,
  lexicon: false,
  actions: false,
};
